// Offline play's frame step (main.ts hands it to matchView.ts as `stepSim`): the pre-match countdown, then
// a fixed-step accumulator over the local core Game.
import { RULES, STEP_DT, type Game } from '../core/game.js';
import type { LocalGameView } from './gameView.js';

const MAX_STEPS_PER_FRAME = 5;

export function createOfflineStepper(game: Game, view: LocalGameView) {
  let acc = 0;
  view.countdown = RULES.countdown;
  return {
    /** Returns how much sim time passed — see MatchViewDeps.stepSim. */
    step(dt: number): number {
      // Frozen on the results screen: core would otherwise restart the match under it after 6 s.
      if (game.winner) { acc = 0; return dt; }
      // Pre-match countdown: bots and clock wait with everyone else; wall-clock dt keeps idle clips playing.
      if (view.countdown > 0) { view.countdown = Math.max(0, view.countdown - dt); return dt; }
      acc += dt;
      let steps = 0;
      // game.events now holds everything every sub-step this frame emitted; driveAnims/fx/hud all read
      // it once, then it is cleared — same single end-of-frame clear the prototype did after one
      // update() call. The mixer advances by exactly what the sim advanced (steps * STEP_DT), not the
      // wall-clock dt: they only differ when the step budget caps (a real hitch), and diverging there is
      // exactly what let a one-shot finish early against a sim that hadn't actually caught up.
      while (acc >= STEP_DT && steps < MAX_STEPS_PER_FRAME) { game.step(); acc -= STEP_DT; steps++; }
      if (steps === MAX_STEPS_PER_FRAME) acc = 0;  // can't keep up: drop the backlog instead of a death spiral
      return steps * STEP_DT;
    },
    /** «Ещё матч»: a fresh match, with its own countdown. */
    rematch() {
      game.reset();
      acc = 0;
      view.countdown = RULES.countdown;
    },
  };
}
